export default {
    van: {
        name: 'Name',
        confirm: 'Confirm',
        cancel: 'Cancel',
    },
    app: {
        confirm: 'Confirm',
        cancel: 'Cancel',
        skip: 'Skip',
        request: {
            error_info: 'Error Info',
            copy: 'Copy'
        },
        message: {
            hello: 'Hello, World',
        },
        home: {
            search_area: 'Dealer Area',
            search_area_content: 'Dealer Address',
            gotothis: 'Go to this place',
            area_select: 'Select Address',
            selfplace: 'Current Location',


            dealerfullname: 'Dealer Name',
            dealeraddress: 'Dealer Address',
            map_store_query_title: 'Store Search',
            map_store_location_fallback_hint: ' (Location permission not granted, using default address)',
            map_store_select_province: 'Select Province',
            map_store_search_province_placeholder: 'Search province',
            map_store_search_store_placeholder: 'Search store name',
            map_store_search_store_or_code_placeholder: 'Search province or store',
            map_store_empty_line1: 'No stores found in this province',
            map_store_empty_line2: 'Try searching stores in other provinces',
            map_store_empty_area_line1: 'No stores found in this area',
            map_store_empty_area_line2: 'Try searching stores in other areas',
            map_store_nav_button: 'Navigate',
            map_store_overview_button: 'Overview',
            map_store_refresh_button: 'Refresh stores',
            map_store_all_provinces: 'All provinces',
            map_country_china: 'China',
            map_country_malaysia: 'Malaysia',
            map_region_label: 'Region',
            map_loading: 'Loading map...',
            map_region_switch_loading:
                'Loading in progress. Please wait before switching country.',
            map_popup_auth_date_prefix: 'Authorized Date: ',
            map_popup_distance_prefix: 'Distance: ',
            map_popup_nav_to: 'Navigate',
            map_popup_copy_address: 'Copy',
            map_nav_getting_location: 'Getting location...',
            map_nav_location_unavailable_title: 'Unable to get your location',
            map_nav_location_unavailable_message:
                'Unable to get your current location. Continue navigation? You can enter the start point in the map.',
            map_nav_continue: 'Continue',
            map_nav_cancel: 'Cancel',
            map_nav_popup_blocked_title: 'Pop-up blocked',
            map_nav_popup_blocked_message:
                'Your browser blocked the navigation window. Tap the button below to open navigation. You will stay on this map page.',
            map_nav_popup_blocked_open: 'Open navigation',
            map_nav_popup_blocked_open_current_message:
                'Unable to open a new window. Open navigation in this tab? You will leave this map page.',
            map_nav_popup_blocked_open_current: 'Open in this tab',
            map_nav_wechat_browser_title: 'Open in browser',
            map_nav_wechat_browser_message_ios:
                'WeChat cannot open the map app directly. Tap ··· at the top right and choose "Open in Safari", then tap Navigate again.',
            map_nav_wechat_browser_message_android:
                'WeChat cannot open the map app directly. Tap ··· at the top right and choose "Open in browser", then tap Navigate again.',
            map_nav_wechat_browser_confirm: 'Got it',
            map_nav_ios_map_apple: 'Apple Maps',
            map_nav_ios_map_google: 'Google Maps',
            map_nav_ios_map_picker_title: 'Choose navigation app',
            map_geo_unsupported: 'Geolocation is not supported by this browser',
            map_geo_failed: 'Failed to get location',
            map_geo_permission_denied: 'Location permission denied',
            map_geo_unavailable: 'Unable to determine your location',
            map_geo_timeout: 'Location request timed out',
            map_popup_location_error: 'Store location exception',
            map_geolocation_watchdog_timeout:
                'Location timed out. Using the default area.',
        },
        scheme: {
            nomoredata: 'No more data',
            author: 'Author',

        },
        schemedetail: {
            errordata: 'Data Error',
        },


        login: {
            user_type: 'User Type',
            user_type_placeholder: 'Please select user type',
            phone: 'Phone',
            phone_placeholder: 'Please enter phone number',
            code: 'SMS Code',
            code_placeholder: 'SMS Code',
            send_code: 'Send Code',
            login: 'Login',
            phone_verify: 'Please enter a valid phone number',
            imagecode_verify: 'Please enter the Captcha code',
            send_code_finish: 'Verification code sent',
            code_count: 's to resend',
            login_success: 'Login successful',

            user_type_person: 'Individual',
            user_type_dealer: 'Dealer',

            captcha: 'Captcha Code',
            captcha_placeholder: 'Enter captcha',

            user_registe: 'User Registration',
            // dealer_user_registe: 'Dealer User\nRegistration',
            // dealer_user_registe: 'To be a registered\nDealer User',
            dealer_user_registe: 'To be a registered\ndealer user',


            // dealer_registe: 'Dealer\nRegistration',
            // dealer_registe: 'To be a registered\nDealer',
            dealer_registe: 'To be a registered\ndealer',




            gotoregister: 'Please register first',

            selectaccount: 'Select Account',

            roleregister: "Register",

            input_sms_code: 'Please enter the SMS verification code',
            quick_register_title: 'Complete your profile',
            quick_register_subtitle: 'This phone number is not registered yet.\nSet a username to sign up and log in.',
            quick_register_name_label: 'Username',
            quick_register_name_placeholder: 'Enter username',
            quick_register_name_required: 'Please enter a username',
            quick_register_confirm: 'Register & Sign In'


        },
        // 经销商注册
        dealerregister: {
            dealer_register: 'Distributor Registration',
            dealerType: 'Dealer\nType',
            dealerAddress: 'Region Selection',
            dealerFullAddress: 'Dealer Address',
            dealerName: 'Dealer\nName',
            dealerShortName: 'Dealer Short Name',
            dealerNamePlaceHolder: 'Please enter the dealer name',
            userName: 'Contact Name',
            userEmail: 'Contact Email',
            userPhone: 'Contact Phone Number',
            phone: 'Contact Phone',
            imageCode: 'Captcha Code',
            register: 'Register',
            login: 'Login',
            dealerBrand: 'Dealer\nBrand',
            tips: '*After submitting the registration information, it needs to be reviewed and approved.\n(Online review or on-site review by our staff depending on the situation.)',

            dealerSuperiorName: 'Parent Distributor',
            dealerSuperiorNamePlaceHolder: 'If there is no parent distributor, please ignore',




            oemdealer: 'OEM',
            dealer: 'DISTRIBUTOR',
            channel: 'CHANNEL_ONLY',
            // dealershop: 'Dealer Shop',

            business_license: 'Business License',
            business_registration_certificate: 'Business Registration Certificate',

            business_license_code: 'Unified Social Credit Code',
            business_registration_certificate_code: 'Business Registration Number',

        },

        dealeruserregister: {
            dealer_user_register: 'Dealer User Registration',
            dealerType: 'Dealer',
            dealerTypePlaceHolder: 'Please select a dealer',

            userName: 'Name',
            userNamePlaceHolder: 'Please enter your name',

            userEmail: 'Email',
            userEmailPlaceHolder: 'Please enter your email',

            userPhone: 'Phone',
            userPhonePlaceHolder: 'Please enter your phone number',

            imageCode: 'Captcha Code',

            register: 'Register',
            dealerRegister: 'Dealer Registration',
            login: 'Login',

            dealerTypeSelectTips: 'No dealers available. Please register a dealer first.'
        },

        userregister: {
            user_register: 'User Registration',
            userName: 'Name',
            userNamePlaceHolder: 'Please enter your name',
            userEmail: 'Email',
            userEmailPlaceHolder: 'Please enter your email',

            userPhone: 'Phone',
            userPhonePlaceHolder: 'Please enter your phone number',

            imageCode: 'Captcha Code',
            register: 'Register',
            login: 'Login',


            register_success: 'Registration successful',




        },


        qa: {
            // Warranty Creation
            qaform: {
                carinfo: 'Vehicle Information',
                brand: 'Car Brand',
                brandPlaceHolder: 'Car Brand',
                carstyle: 'Car Model',
                carstylePlaceHolder: 'Car Model',
                carNo: 'License Plate Number',
                carNoPlaceHolder: 'License Plate Number',
                carCjNo: 'Vehicle Identification Number',
                carCjNoPlaceHolder: 'Vehicle Identification Number',
                carOwnerName: 'Car Owner Name',
                carOwnerNamePlaceHolder: 'Car Owner Name',
                phoneNumber: 'Phone Number',
                phoneNumberPlaceHolder: 'Phone Number',
                ownerphoneNumberPlaceHolder: 'Owner Phone Number',

                productinfo: 'Product Information',
                productName: 'Product',
                productNamePlaceHolder: 'Product',

                productNo: 'Serial Number',
                productNoPlaceHolder: 'Serial Number',

                productExpire: 'Warranty',
                productExpirePlaceHolder: 'Warranty',

                scanProductInfo: 'Scan to Get Product Information',

                doForminfo: 'Installation Information',
                doDate: 'Date',
                doValidDate: 'Installation Date',
                doDatePlaceHolder: 'Click to Select Date',
                getProductInfo: 'Please Get Product Information First',
                fullcar: 'Select All',
                doCarShop: 'Store',
                doCarShopPlaceHolder: 'Click to Select Store',
                doPrice: 'Price',
                doPricePlaceHolder: 'Enter Actual Transaction Amount',

                qacarcontent: 'Warranty Content',

                qacarimage: 'Installation Photos',
                qacarzhengmian: 'Front Installation Photo',
                qacarcemian: 'Side Installation Photo',
                qacarbeimian: 'Rear Installation Photo',
                qacarshop: 'Vehicle and Storefront Photo',
                qacarjuanhao: 'Clear Roll Number Photo',
                qacarjuanhaoandcar: 'Roll Number and Vehicle Photo',

                submit: 'Submit',


                qaformsuccess: 'Creation Successful',

                imagemustsix: 'Please upload six images',

                productinfo_first: '(Scan to Get Product Information first)',

                warranty_days: 'days',
                warranty_year: 'Years',


                contact_customer_service: 'Contact Customer Service',

                contact_customer_service_wechat: "WeChat Customer Service",
                contact_customer_service_wechat_click: "Click to contact a live agent",

                contact_customer_service_phone: "Phone Support",


            },
            // 质保搜索
            qasearch: {
                searchcontent: 'Search warranty card by phone number',
                phone: 'Phone',
                phonePlaceHolder: 'Please enter phone number',
                imageCode: 'Captcha Code',
                imageCodePlaceHolder: 'Captcha Code',
                search: 'Search',
                qalist: 'Warranty List',

                noqatips: 'The current phone number has no warranty',

            },

            qareview: {
                reviewtab: 'Not Confirmed',
                reviewing: 'Confirming',
                success: 'Confirmed',
                failed: 'Rejected',

                submitsuccess: 'Submission Successful',
                submit: 'Submit',
                reviewsuccess: 'Review Approved',
                reviewfailed: 'Review Rejected',
                review: 'Review',
                dateStart: 'Date From',
                dateEnd: 'Date To',

                searchtips: 'Fuzzy Search',
                searchtipsPlaceHolder: 'Please enter keywords',

                search: 'Search',

                reject_reason: 'Rejection Reason',
                reject_reason_placeholder: 'Please enter the rejection reason',








            },
            // 质保详情
            qadetail: {
                carinfo: 'Vehicle Information',
                brand: 'Car Brand',
                carstyle: 'Car Model',
                carNo: 'License Plate Number',
                carCjNo: 'VIN (Vehicle Identification Number)',
                carOwnerName: 'Owner Name',
                phoneNumber: 'Phone Number',
                productinfo: 'Product Information',
                productName: 'Product',
                productNo: 'Batch Number',
                productExpire: 'Warranty',
                doForminfo: 'Installation Information',
                doDate: 'Date',
                doPart: 'Installed Part',
                doCarShop: 'Store',
                doPrice: 'Price',
                qacarcontent: 'Warranty Content',
                qacarimage: 'Installation Photos',
                qacarzhengmian: 'Front Installation Photo',
                qacarcemian: 'Side Installation Photo',
                qacarbeimian: 'Rear Installation Photo',
                qacarshop: 'Car and Storefront Photo',
                qacarjuanhao: 'Clear Batch Number Photo',
                qacarjuanhaoandcar: 'Batch Number and Vehicle Photo',
            },
            qaitem: {
                id: 'Warranty Card ID',
                warrantyCode: "Warranty Code",
                starttime: 'Warranty Start Date',
                createtime: 'Warranty Creation Date',
                car: 'Car',
                product: 'Product',



                status_not_confired: 'NOT_CONFIRMED',
                status_confirming: 'CONFIRMING',
                status_confirmed: 'CONFIRMED',
                status_rejected: 'REJECTED'
            }
        },

        mineitem: {
            myqaitem: 'My Warranty',
            mysecuritycheckitem: 'Serial Number Verification',
            myshopitem: 'My Purchase Plan',
            mystockitem: 'Inventory Management',
            mygoodsitem: 'Shipping Management',
            myqareviewitem: 'Warranty Management',
            mydealermanageritem: 'Distributor/Retailer Management',
            myconstructionitem: 'Construction Management',
            mycouponitem: 'My Coupon',
            couponmanageitem: 'Coupon Management',
            mycouponcheckitem: 'Coupon Redemption',
            mycouponreportitem: 'Coupon Code Report',
            myinstructionitem: 'Manual',
            mylanguageitem: 'Language Switch',
            mychartqaitem: 'Warranty Report',
            mychartpurchaseorderitem: 'Purchase Order Report',
            workerlist: 'Employee Management',
            workerdetail: 'Employee Information',

            mystockinitem: 'Stock In Management',
            mycreatestockitem: 'Create inventory',
            mystockoutitem: 'Stock Out Management',
            mycreateqaitem: 'Create Warranty',
            myqueryqaitem: 'Warranty Inquiry',
            myclaimitem: 'Claim',
            myclaimapprovalitem: 'Claim Approval',
            mycompensationitem: 'Compensation',
            myorderitem: 'Subordinate Purchase Plan Management',
            mylogout: 'Log Out',
            myloginin: 'Log In',

            mypaymentorderitem: 'Place Purchase Order',
            mypaymentordermanageritem: 'Purchase Order Management',
            mypaymentorderbillmanageritem: 'Payment Order Management',
            myproductpurchaseitem: 'Product Purchase',
            wechat_purchase_hint: 'WeChat cannot directly launch Alipay. Tap "···" at the top right, choose "Open in Browser", then select your items to pay.',

            myservicecentermanager: "Service Center Management",
            addressmanager: "Address Management",
            warehousemanager: 'Warehouse Manager',
            reportmanager: 'Business Reports',
            storemanager: 'Store Management',

            myservicepurchase: 'Purchase Services',



        },

        stock: {
            // stockin: 'Stock In',
            // stockrecord: 'Inventory',
            // stockused: 'Used',
            // stockunin: 'Unstocked',

            stockin: 'In Stock',
            stockused: 'Out Of Stock',
            stockunin: 'In Pending Stock',

            stockinsuccess: 'Stock in Successful',
            stockoutsuccess: 'Stock Out Successful',



            stockscancode: 'Scan to stock in',
            stockrecord: 'Stock-in record',

            stockid: 'Stock ID',


            stock_stock_in: 'Stock In',
            stock_stock_out: 'Stock Out',




        },


        // 多语言切换界面
        language: {
            btn_complete: 'Done',
            switch_label: 'Language',
            simplified: 'Simplified Chinese',
            traditional: 'Traditional Chinese',
            english: 'English',
            malay: 'Bahasa Melayu',
        },
        mine: {
            username: 'Username',
            changerole: 'Switch Role',
            changerolddesc: 'Do you want to switch roles?',

            norolecanchagen: 'No roles available to switch to'

        },

        // 导航相关
        nav: {
            qalist: 'Warranty List',
            qacreate: 'Warranty Creation',
            securitycheck: 'Serial Number Verification',
            qadetail: 'Warranty Details',
            showlist: 'Purchase List',
            showorderlist: 'Order List',
            storelist: 'Store List',
            showorder: 'Place Purchase Order',
            shopdetail: 'Purchase Details',
            shoporderdetail: 'Order Details',
            stock: 'Inventory Management',
            stockin: 'Stock In Management',
            stockout: 'Stock Out Management',
            purchase: 'Shipping Management',
            purchasedetail: 'Shipping Details',
            qareview: 'Warranty Management',
            dealershopmanager: 'Distributor/Retailer Management',
            dealershopmanagerdetail: 'Details',
            qasearch: 'Warranty Search',
            qapublicquery: 'Auto Film Warranty',
            register: 'Register',
            scancode: 'Scan Code',
            detail: 'Details',
            languagechange: 'Language Switch',
            storecreate: 'Store Creation',
            dealercreate: 'Dealer Creation',

            construction: 'Construction Management',
            construction_pending: 'Construction Pending',
            construction_completed: 'Construction Completed',
            construction_accepted: 'Construction Acceptance',
            construction_detail: 'Construction Details',

            coupon: 'My Coupon',
            coupon_detail: 'Coupon Details',
            coupon_manage: 'Coupon Management',
            coupon_check: 'Coupon Redemption',
            charts_coupon: 'Coupon Code Report',
            manual: 'Manual',
            charts_qa: 'Warranty Report',
            charts_po: 'Purchase Order Report',
            charts_inoutstock: 'Inventory Inbound/Outbound Report',

            role_select: 'Select Role',
            dealer_register: 'Distributor Registration',
            direct_vendor_register: 'Direct Vendor Registration',
            dealer_shop_register: 'Retailer Registration',
            service_provider_register: 'Service Provider Registration',
            register_address_map: 'Select Detailed Address',

            dealer_worker_register: 'Distributor Employee Registration',
            service_worker_register: 'Service Provider Employee Registration',
            shop_worker_register: 'Retailer Employee Registration',
            consumer_user_register: 'User Registration',

            qrcode_register: 'QR Code Registration',

            workerlist: 'Employee Management',
            workerdetail: 'Employee Information',


            purchase_order: 'Order Management',
            purchase_order_detail: 'Order Details',
            in_stock_detail: 'Stock-In Details',
            paymentorderbill: 'Payment Order List',
            paymentorderbilldetail: 'Payment Details',


            scandetail: 'Scan Details',
            stockoutdetail: 'Stock-Out Details',
            stockindetail: 'Stock-In Details',
            stockstockdetail: 'Inventory Details',

            servicecentermanager: "Service Center Management",
            servicecentercreate: "Service Center Creation",
            servicecenterdetail: "Service Center Details",


            addressmanager: "Address Management",
            addresscreate: "Create Address",
            addressdetail: "Details",

            warehousemanager: 'Warehouse Manager',
            warehousecreate: 'Create Warehouse',

            ordersummary: 'Order Summary',

            orderproductout: 'Shipment Management',

            chartslist: 'Business Reports',

            servicepurchase: 'Purchase Service',

            paysuccess: 'Payment Successful',

            servicelistmanager: 'Service Order Management',

            consumer_order_detail: 'Order Details',
            consumer_order_list: 'My Orders',
            consumer_order_info: 'Order Details',
            consumer_payment_bill_list: 'Payment Management',
            consumer_payment_bill_info: 'Payment Details',
            consumer_store_list: 'Select Store',
            consumer_shop: 'Select Products',

            claimlist: 'Claim List',
            claimapply: 'Claim Application',
            claimdetail: 'Claim Detail',
            claimapproval: 'Claim Approval',
            claimapprovaldetail: 'Approval Detail',
            compensation: 'Compensation',
            compensationdetail: 'Compensation Detail'
        },

        // 索赔详情
        claimdetail: {
            claimstatus: 'Claim Status',
            statuspending: 'Pending Review',
            statusapproved: 'Approved',
            statusrejected: 'Rejected',
            loading: 'Loading...',
            applytime: 'Applied At',
            approval_time: 'Reviewed At',
            approval_opinion: 'Review Comment',
            productinfo: 'Product Info',
            productname: 'Product Name',
            product_category: 'Product Category',
            serialnumber: 'Serial No.',
            compensation_party: 'Compensation Party',
            compensation_type: 'Party Type',
            compensation_name: 'Party Name',
            warranty_info: 'Linked Warranty',
            warranty_code: 'Warranty No.',
            valid_period: 'Valid Period',
            phone: 'Phone',
            questionnaire: 'Questionnaire',
            media: 'Photos & Videos',
            notfound: 'Claim record not found',
            video_load_failed: 'Failed to load video, please try again later'
        },

        // 索赔审批
        claimapproval: {
            all: 'All',
            pending: 'Pending Review',
            approved: 'Approved',
            rejected: 'Rejected',
            id: 'ID',
            product_name: 'Product',
            serial_number: 'Serial No.',
            claim_party: 'Claim Party',
            warranty_code: 'Warranty No.',
            empty: 'No {label} records',
            emptyall: 'No records',
            viewdetail: 'Tap to view and review'
        },

        // 索赔审批详情
        claimapprovaldetail: {
            flow_submitted: 'Submitted',
            claim_party_info: 'Claim Party Info',
            claim_party: 'Claim Party',
            approve: 'Approve',
            reject: 'Reject',
            approve_title: 'Approve Claim',
            approve_placeholder: 'Enter approval reason…',
            approve_required: 'Please enter an approval reason',
            reject_title: 'Reject Claim',
            reject_placeholder: 'Enter rejection reason…',
            reject_confirm: 'Confirm Reject',
            cancel: 'Cancel',
            approve_confirm: 'Confirm Approve',
            reject_required: 'Please enter a rejection reason',
            approve_success: 'Approved',
            reject_success: 'Rejected',
            operate_failed: 'Operation failed, please try again'
        },

        // 索赔申请
        claimapply: {
            claim_type: 'Claim Type',
            link_warranty: 'Link Warranty',
            product_no: 'Product Serial Number',
            product_info: 'Product Info',
            questionnaire: 'Questionnaire',
            required_select: 'Required',
            required_fill: 'Required',
            type_warranty: 'Warranty Link',
            type_product: 'Product Claim',
            select_warranty_placeholder: 'Select warranty record',
            manual_input: 'Manual Input',
            scan_input: 'Scan',
            product_no_placeholder: 'Enter serial number',
            verify: 'Verify',
            scan_hint: 'Tap to scan serial number',
            product_category: 'Product Category',
            product_name: 'Product Name',
            serial_number: 'Serial Number',
            compensation_party: 'Compensation Party',
            compensation_type: 'Party Type',
            compensation_name: 'Party Name',
            input_placeholder: 'Enter ',
            file_type_image: 'Image',
            file_type_video: 'Video',
            multi_select_hint: '(Multi-select)',
            check_questionnaire: 'Please check if the questionnaire is filled correctly',
            submit: 'Submit Claim',
            select_warranty: 'Select Warranty',
            close: 'Close',
            loading: 'Loading...',
            warranty_code: 'Warranty Code',
            valid_period: 'Validity',
            product: 'Product',
            phone: 'Phone',
            vin: 'VIN',
            warranty_empty: 'No matching warranty records',
            file_min: 'At least {n}',
            file_max: 'Up to {n}',
            file_range: 'At least {min}, up to {max}',
            error_required: 'This field is required',
            error_length: 'Length must be {min}~{max} characters',
            error_number: 'Value must be {min}~{max}',
            error_format: 'Invalid format',
            error_file_min: 'Upload at least {n} file(s)',
            error_file_max: 'Upload at most {n} file(s)',
            toast_select_claim_type: 'Please select claim type',
            toast_select_warranty: 'Please select a warranty record',
            toast_product_no: 'Please enter or scan the serial number',
            toast_verify_failed: 'Serial number verification failed',
            toast_verify_success: 'Verification successful',
            toast_submit_success: 'Claim submitted',
            toast_submit_failed: 'Submission failed, please try again later'
        },

        // 索赔列表
        claimlist: {
            all: 'All',
            pending: 'Pending Review',
            approved: 'Approved',
            rejected: 'Rejected',
            serial_number: 'Serial No.',
            compensation_party: 'Compensation Party',
            warranty_code: 'Warranty No.',
            approval_opinion: 'Review Comment',
            id: 'ID',
            product_name: 'Product',
            empty: 'No {label} records',
            emptyall: 'No records',
            empty_sub: 'Submit a claim if you find any product issue',
            create: 'Submit Claim'
        },


        // 消费者扫码订单（个人消费者）
        consumerorder: {
            order_no: 'Order No.',
            product_list: 'Items',
            product_amount: 'Items Amount',
            freight: 'Shipping',
            freight_free: 'Free',
            total_amount: 'Total',
            pay_amount: 'Payable',
            create_order: 'Create Order',
            create_payment: 'Create Payment',
            first_select_address: 'Please select a delivery address',
            order_success: 'Order placed',
            go_to_payment: 'Pay now?',
            payment_confirm: 'Pay',
            payment_back: 'Later',
            payment_method: 'Payment method',
            payment_success: 'Payment successful',
            payment_failed: 'Payment failed to initiate, please try again later',
            alipay_querying: 'Checking payment status, please wait…',
            alipay_back: 'Back',
            alipay_scan_tip: 'Scan to pay with Alipay',
            alipay_scan_sub: 'Payment status will be checked automatically',
            company_name: 'Company name',
            bank_name: 'Bank name',
            bank_account: 'Account no.',
            payment_time: 'Payment time',
            payment_time_now: 'Current time',
            payment_time_manual: 'Manual',
            select_full_date: 'Select full time',
            search_order_placeholder: 'Search by order ID',
            tab_all: 'All',
            tab_unpay: 'Unpaid',
            tab_unconfirmed: 'Pending',
            tab_partpay: 'Partial',
            tab_payed: 'Confirmed',
            tab_confirmed: 'Confirmed',
            tab_closed: 'Closed',
            status_confirmed: 'Confirmed',
            status_pending_payment: 'Pending Payment',
            status_confirming: 'Pending Confirmation',
            payment_bill_manage: 'Payment Management',
            search_bill_placeholder: 'Search by payment ID',
            payment_bill_id: 'Payment ID',
            transaction_no: 'Transaction Number',
            payment_subject_type: 'Payer Type',
            payment_subject: 'Payer',
            receive_account: 'Receiving Account',
            payment_amount: 'Payment Amount',
            order_id: 'Order ID',
            order_person: 'Buyer',
            order_date: 'Order time',
            order_info: 'Order info',
            order_status: 'Status',
            order_time: 'Order time',
            price_detail: 'Amount details',
            really_pay: 'Actual paid',
            order_payment: 'Payment info',
            related_order: 'Related Orders',
            create_pay_time: 'Created time',
            payment_date: 'Payment time',
            confirm_date: 'Confirm time',
            loading: 'Loading…',
            empty: 'No orders',
            empty_hint: 'Try another status, or scan to place an order',
            retailer: 'Retailer',
            retailer_id: 'Retailer ID',
            includes: 'Includes',
            logistics_need: 'Shipping',
            logistics_none: 'No shipping',
            logistics_optional: 'Optional',
            delivery_title: 'Delivery',
            delivery_need: 'Ship to me',
            delivery_none: 'No shipping',
            no_delivery_hint: 'No shipping needed',
            no_delivery_desc:
                'No delivery address needed. You can place your order directly.',
            leave_confirm:
                'You will need to scan the QR code again to come back to this page',
            leave_confirm_ok: 'Leave',
            leave_confirm_cancel: 'Stay',
            consumer_only_hint: 'This page is for individual consumers only. Your account has no access.',
            consumer_only_confirm: 'OK',
            data_error: 'Data Error',
            retailer_select_title: 'Select Retailer',
            retailer_placeholder: 'Select a retailer',
            retailer_search_placeholder: 'Search by store name',
            retailer_locating: 'Locating…',
            retailer_empty: 'No retailers found',
            shop_search_placeholder: 'Search by store name',
            shop_empty: 'No store found',
            empty_product: 'No products',
            retailer_required: 'Please select a retailer first',
            retailer_change: 'Change',
            alipay_wechat_guide_title: 'Open in your browser to finish payment',
            alipay_wechat_guide_desc:
                'WeChat cannot open Alipay directly. Follow the steps below:',
            alipay_wechat_guide_step1: 'Tap "···" at the top right',
            alipay_wechat_guide_step2: 'Choose "Open in browser"',
            alipay_wechat_guide_step3: 'Tap "Pay now" again to complete',
            alipay_wechat_pay_message:
                'WeChat cannot open Alipay directly. Tap "···" at the top right and choose "Open in browser" to pay again, or use bank transfer instead.',
            alipay_wechat_pay_confirm: 'Got it'
        },


        // 购物相关
        shop: {
            order: 'Place Order',
            clearcart: 'Clear Cart',
            selectall: 'Select All',


            addCart: 'Please select specifications first',
            shopsuccess: 'Order Successful',

            shoplistid: 'Purchase Order ID',
            showlisttime: 'Purchase Date',
            showlistdealer: 'Dealer',
            showlistphone: 'Purchaser Phone Number',

            addToCartFirst: 'Please add to the cart first',

            getshop: 'Purchase',

            addToCart: 'Add to cart',
            product_detail: 'Product Details',
            no_detail: 'No details yet',
            view_detail: 'View Details',

            allproduct: 'Quantity',
            allprice: 'Total',

            order_status_unreview: 'Pending review',

            price_begin: 'Starting from',

            nopermission: 'Non-agent users do not have permission to view product information.',


            popup_confirm: 'Back',
            popup_changerole: 'Switch Role',

            purchase_people: 'Purchaser',
            purchase_from: 'Purchasing Company',

            confirm_order: 'Confirm Order',


        },


        purchase: {
            dateStart: 'Date From',
            dateEnd: 'Date To',
            searchtips: 'Fuzzy Search',
            searchtipsPlaceHolder: 'Please enter keywords',
            search: 'Search',
            unpurchase: 'Not Shipped',
            purchased: 'Shipped',


            scanstockout: 'Scan for Stock Out',

            id: 'Purchase Order ID',
            time: 'Purchase Time',
            dealer: 'Purchasing Dealer',
            dealerphonenumber: 'Purchaser Phone Number',

            dealername: 'Dealer Name',
            dealeraddress: 'Dealer Address',
            dealercontactname: 'Contact Name',
            dealercontactphone: 'Contact Phone Number',

            dealerinfo: 'Dealer Information',
            productinfo: 'Product Information',


            gopurchase: 'Purchase',

            search_input_purchase_placeholder: 'Enter purchase order ID to search',

            purchase_list: 'Purchase List',

            to_now: 'To Date',


        },
        purchasedetail: {
            goodsinfo: 'Product information'
        },

        // 防伪相关 
        securitycheck: {
            securitycheckscancode: 'Scan the code to check for authenticity',
            productscan: 'Serial Number',
            resultsuccess: 'Genuine Product',
            resulterror: 'Counterfeit Product',
            resulterrortwo: 'Serial number not found',
            resulterrordetail: 'Serial number not found. Please contact your retailer or distributor for manual verification to get detailed product information.',




            tips: 'After registering for electronic warranty, you can enjoy official warranty and various value-added services',
            thanks: 'Congratulations, this product is a genuine Castrol automotive film product.\nThank you for your support!',
            thankserror: 'Please contact the official for assistance',
            thankserrortwo: 'Serial number not found\nPlease contact your retailer or distributor for manual verification to get detailed product information.',
            jump: 'Jump',
            productverify: 'Product authenticity verification',
            productstyle: 'Product Model',
            expire: 'Warranty Period',

            qacreate: 'Create\nWarranty'
        },

        account: {
            title: 'Bank Transfer Account Information',

            companynametitle: 'Company Name',
            companynamevalue: 'Shanghai Guangtai Qiaozhi Industrial Development Co., Ltd.',

            tintitle: 'Taxpayer Identification Number',
            tinvalue: '91310118560192303A',

            addresstitle: 'Address',
            addressvalue: 'Room 320, No. 45, Lane 16, Xiangningbang Road, Zhujiajiao Town, Qingpu District',

            phonetitle: 'Phone',
            phonevalue: '64188908',

            banktitle: 'Bank Name',
            bankvalue: 'Agricultural Bank of China, Shanghai Weihai Road Branch',

            accounttitle: 'Remittance Account',
            accountvalue: '03304700040011734',

            merchantnotitle: 'Merchant No.',
            parentmerchantnotitle: 'Parent Merchant No.',
            nopaymentmethod: 'No payment method available',
            alipay: 'Alipay',
            banktransfer: 'Bank Transfer',

            tips: '*After placing an order, the remittance account information can be found on the purchase details page.'


        },


        // 扫码相关 
        qrcode: {
            cameraname: 'Camera',
            selectcamera: 'Select Camera',
            tips: 'Is there a problem scanning the code? Click to switch cameras',
            btntips: 'Switch',

            fromalbum: 'Select from Album',
            imageverifyerror: 'Unable to recognize the image',
            initerror: 'Decoder initialization failed',

            changecamera: 'Switch Camera',
            album: 'Album',
            scan_end: 'Stop Scanning',
            scan_preview: 'Scan Preview',
            scan_summary: 'Scan Summary',
            scan_success: 'Scan successful',
            please_scan_first: 'Please scan first',

            barcodetips: 'Align the barcode within the frame to scan',

            verify_success: 'Validation successful'

        },
        dealershopmanager: {
            dealername: 'Distributor',
            shopname: 'Store',
            retailer: 'Retailer',

            item: {
                id: 'ID',
                fullname: 'Full Name',
                address: 'Address',
            },
            detail: {
                id: 'ID',
                fullname: 'Full Name',
                address: 'Address',
                shortname: 'Short Name',
                brand: 'Brand',
                level: 'Level',
                createtime: 'Creation Time'
            },
            createshop: 'Create Store',
            createdealer: 'Create Distributor',
            createretailer: 'Create Retailer',
            search_name: 'Search by name',

            type: {
                picker_title: 'Select retailer type',
                picker_subtitle: 'Choose the type of retailer to create',
                retailer: 'Standard retailer',
                retailer_desc: 'Sales and installation services',
                sales_only: 'Sales-only retailer',
                sales_only_desc: 'Sales only, no installation',
                sales_only_short: 'Sales only',
                cancel: 'Cancel'
            },

            shop: {
                title: 'Store Details',
                shopinfo: 'Store Information',
                shopname: 'Store Short Name',
                shopfullname: 'Store Full Name',
                shopaddress: 'Store Address',
                shopphonenumber: 'Contact Phone Number',
                submit: 'Submit',
                verifyone: 'Business License',

                dealerfullname: 'Dealer Full Name',
                dealerlevel: 'Dealer Level',

                verifyonefront: 'Document',
                verifyoneback: 'Document',
                verifyoneshopimg: 'Document',

                emptytips: 'Incomplete information',

                submitsuccess: 'Information submitted successfully, under review...',


                storeaddress: 'Store Address',
            },
            dealer: {
                dealerinfo: 'Dealer Information',
                title: 'Dealer Details',
                submit: 'Submit',
                nomoreimages: 'You can upload up to three photos',
                submitsuccess: 'Information submitted successfully, under review...'
            },
            tips: '*After submitting the creation information, it needs to be reviewed and approved.\n(Depending on the situation, our staff will conduct an online or on-site review.)',

            businessLicenseNumber: 'Business License Number',

        },


        // 施工单
        construction: {
            order_available: "Available for Order",
            order_pending_construction: "Pending",
            order_under_construction: "Ongoing",
            order_construction_completed: "Completed",
            order_accepted: "Accepted",
            order_cancelled: "Cancelled",
            accepted: "Accept",

            item: {
                order_id: "Order ID",
                color: "Color",
                car_style: "Car Model",
                dealer: "Dealer",
                construction_address: "Construction Address",
                construction_time_area: "Construction Time Range",
                selected_construction_time: "Selected Construction Time",
                construction_people: "Construction Workers",

                under_construction_btn_before: "Start Early",
                under_construction_btn_after: "Start Construction"
            },

            pedding_construction: {
                title: "Do you want to start construction?",
                cancel: "Cancel",
                confirm: "Confirm"
            },

            constructioncompleted_detail: {
                title: "Please upload post-construction vehicle photos",
                image: "Image",
                cell_title: "Vehicle Handover Inspection Items",
                defect_name: "Defect Name",
                bubble: "Bubble",
                impurity: "Impurity",
                offset_printing: "Offset Printing",
                indicates_scratch: "Indicates Scratch",
                surface_wrinkle: "Surface Wrinkle",
                surface_damage: "Surface Damage",
                warranty_upload: "Warranty Upload",
                construction_completed: "Construction Completed",
                pedding_construction_accepted: "Waiting for Vehicle Owner Inspection",
                before_completed_tips: "Please upload the signed acceptance form image first",
                cancel: "Cancel",
                confirm: "Confirm"
            },

            constructionaccepted_detail: {
                cell_title: "Vehicle Handover Inspection Items",
                defect_name: "Defect Name",
                bubble: "Bubble",
                impurity: "Impurity",
                offset_printing: "Offset Printing",
                indicates_scratch: "Indicates Scratch",
                surface_wrinkle: "Surface Wrinkle",
                surface_damage: "Surface Damage",
                warranty_upload: "Warranty Upload",
                images_title: "Post-Construction Photos",
                accepted: "Accept",
                construction_completed: "Construction Completed",
                before_completed_tips: "Please upload post-construction vehicle photos",
                pedding_construction_accepted: "Accept the inspection result?",
                cancel: "Cancel",
                confirm: "Accept",
                completed_photos: "Construction Completion Photos",
                owner_qrcode_photos: 'Owner Acceptance QR Code',
            },

            construction_detail: {
                title: "Construction Order Details",
                order_id: "Order ID",
                color: "Color",
                car_style: "Car Model",
                construction_time_area: "Construction Time Range",
                construction_address: "Construction Address",
                selected_construction_time: "Selected Construction Time",
                salespeople_phonenumber: "Salesperson Phone Number",
                owner_phonenumber: "Owner Phone Number",
                worker: "Construction Workers",
                construction_part: "Construction Area",
                comment: "Comment",
                images_title: "Construction Completion Photos",
                owner_images_title: "Inspection Photos"
            }
        },

        coupon: {
            nav: {
                unused: "Unused",
                used: "Used",
                invalid: "Expired",

                dealer_unused: 'Issued',
                dealer_used: 'Redeemed',
                dealer_invalid: 'Expired'
            },

            detail: {
                id: "ID",
                verificationcode: "Verification Code",
                name: "Coupon",
                phone: 'User Phone Number',
                store: "Applicable Store",
                usedstore: 'Store Used',
                date: "Valid Date",
                state: "Status",
                check_time: "Verification Time",
                detail: "Details",
                qrcode_title: "Verification QR Code"
            },

            check: {
                securitycheckscancode: "Coupon Verification",
                productscanstate: "Verification Status",
                coupon_id: "Coupon ID",
                coupon_verificationcode: "Coupon Verification Code",
                coupon_name: "Coupon Name",
                coupon_address: "Usage Location",
                coupon_scan_date: "Verification Time",
                coupon_check_yes: "Verification Successful",
                coupon_check_no: "Verification Failed",
                nav_check: "Coupon Verification",
                nav_list: "Verification Records"
            }
        },

        mainbody: {
            dealername: {
                top_title: 'Please enter the full legal name of the merchant/company to be registered',
                tips: '*Please make sure the name you enter exactly matches the name on your business license',
                label: 'Merchant/Company Full Name',
                bottom_content: 'Next',
            },
            dealer: {
                toptitle: 'Please fill in the merchant/company information',
                dealertype: 'Type',
                fullname: 'Merchant/Company Full Name',
                filetype: 'Document Type',
                filetype_placeholder: 'Unified Social Credit Code',
                file_image: 'Document Photo',
                bottom_content: 'Next',
                select_region_first: 'Please select country/province/city/district first',
                region_label: 'Selected region',
                locate_on_map: 'Locate',
                drag_marker_hint: 'Enter the detailed address and tap Locate. Drag the marker if the position is inaccurate.',
                locate_building_approximate: 'Located to the community area only. Please drag the marker to the exact building.',
                longitude: 'Longitude',
                latitude: 'Latitude',
                confirm_address: 'Confirm Address',
                enter_detail_address: 'Please enter the detailed address',
                locate_failed: 'Failed to locate the address. Please check the address or drag the marker manually.',
                confirm_address_invalid: 'Please enter the detailed address and confirm the location on the map',
                detail_address_title: 'Enter Detailed Address',
                detail_address_subtitle: 'Include street name and number for better accuracy',
                map_placeholder: 'Enter the detailed address and tap Locate to show the map here',
                map_style_streets: 'Standard',
                map_style_hybrid: 'Satellite',
                map_switched_satellite: 'Switched to satellite view for rural areas',
                map_panel_tianditu: 'Tianditu Map',
                map_panel_maptiler: 'MapTiler',
                map_panel_maptiler_compare: 'MapTiler Compare (Read-only)',
                map_compare_hint: 'Temporary dual-map compare · Tianditu coordinates are authoritative · MapTiler syncs when the Tianditu marker is dragged',
                geocode_result_title: 'Location Result',
                geocode_input_address: 'Input Address',
                geocode_matched_address: 'Matched Address',
                geocode_source: 'Geocode Source',
                geocode_coord_system: 'Coordinate System',
                geocode_lnglat_pair: 'lng,lat',
                geocode_level: 'Precision Level',
                geocode_manual_adjusted: 'Manually Adjusted',
                geocode_approximate: 'Approximate',
                geocode_copy_lnglat: 'Copy Coordinates',
                geocode_copy_success: 'Coordinates copied',
                geocode_source_tianditu: 'Tianditu',
                geocode_source_maptiler: 'MapTiler',
            },
            dealeruser: {
                toptitle: 'Please fill in the contact person information',
                desc: 'To complete the registration',
                fill_real_name: 'Please enter your real name',
                fill_fake_name: 'Enter username',
                fill_captcha: 'Please enter the image verification code',
                fill_sms_code: 'Please enter the SMS verification code',
                register: 'Register',
            },
            directvendor: {
                top_title: 'Please enter the full name of the direct vendor you want to register',
                label: 'The full name of the direct vendor',
            },
        },


        roleselect: {
            title: 'Thank you for choosing Castrol',
            desc: 'Please select the identity you want to register',

            topdealer: 'Primary Distributor',
            directvendor: 'Direct Vendor',
            service: 'Service Provider',
            consumer: 'Consumer',
            serviceprovider: 'Service Provider',
            other: 'Other',
        },

        qrcoderegister: {
            scan_desc: 'Scan the QR code to become',
            retailer_name: 'Retailer',
            dealer_name: 'Distributor',
            download: 'Download',
            user: 'Scan the QR code to join the company',
            copy: 'Click to Copy Link',
            copysuccess: 'Copy Successful',
            copyfail: 'Copy Failed'
        },


        worker: {
            submit_in: 'Add Employee',
            topsearch: {
                title: 'Please enter employee phone number to search'
            },
            item: {
                user: 'Username',
                phone: 'Phone Number'
            },
            detail: {
                id: 'Employee ID',
                name: 'Full Name',
                phone: 'Phone Number',
                delete: 'Delete Employee'
            },
            deletepopup: {
                title: 'Are you sure you want to delete this employee?',
                confirm: 'Confirm',
                cancel: 'Cancel'
            }
        },

        // 服务商相关
        serviceprovider: {
            fulladdress: 'Full Address',
            belongserviceproviderinfo: 'Affiliated Service Provider',
        },


        distributor: {
            tipsone: 'The current parent distributor does not exist',
            tipstwo: 'The current parent distributor data parsing error',
            parentinfo: 'Parent Distributor'
        },

        retailer: {
            tipsone: 'The specified retailer does not exist.',
            tipstwo: 'Failed to parse retailer data.',
            parentinfo: 'Affiliated Distributor',
            belongshopinfo: 'Affiliated Retailer',

        },

        supplier: {
            tipsone: 'The associated supplier does not exist',
            tipstwo: 'Failed to parse the associated supplier data',

            parentinfo: 'Associated Supplier',
            item: {
                type: 'Type'
            },

            tips: {
                warn: {
                    outboundtargettips: 'Please select an outbound destination first'
                }
            }
        },

        // Direct vendor related
        directvendor: {
            tipsone: 'The associated direct vendor does not exist',
            tipstwo: 'Failed to parse the associated direct vendor data',

            parentinfo: 'Associated Direct Vendor',
        },

        loginroleselect: {
            title: 'Please select a role to log in',
            desc: 'Multiple roles detected. You can switch roles after logging in.',
            system_user: 'System User',
            supplier_user: 'Supplier',
            distributor_user: 'Distributor',
            directvendor_user: 'Direct Vendor',
            retailer_user: 'Retailer',
            individual_user: 'Consumer',
            service_provider_user: 'Service Provider',
            service_personnel: 'Service Personnel'

        },




        newstock: {

            create: {
                addToStockDetail: 'Add to Stock Summary',
                clearAllStockDetail: 'Clear Stock Summary',
                createstock: 'Create Stock',

                addToStockDetailFirst: 'Please add to stock summary first',

                serialnumber: ' Serial Number',
                enterserialnumber: 'Please enter the serial number',

                tips: {
                    batch_input_tips: 'Please enter serial numbers in batch, separated by line breaks',
                    input_serialnumber: 'Please enter the serial number',
                    check_all_count: 'Total recognized quantity:'
                },

                detail: {
                    gostock: 'Stock In',
                    serialnumberlist: 'Serial Number List',
                    success: 'Created Successfully',
                    failed: 'Creation Failed',

                    instock_success: 'Stock-in Successful',

                    no_create_success_stock: 'No successfully created stock'
                }
            },

            in: {
                title_unstockin: 'To Receive',
                title_stockrecord: 'Inbound Log',
                title_querystock: 'Inventory',
                scan_stock_in: 'Scan to Stock In',
                search_placeholder: 'Please enter roll number to search',
                in_stock_date: 'Inbound Date',
                un_in_stock_count: 'To-Receive Qty',
                in_stock_record_count: 'Total Inbound Records',
                plan_purchase_count: 'Total Purchase Qty',
                real_in_count: 'Total Actual Inbound Qty',
                select_purchase_distributor: 'Please select a parent distributor',
                select_warehouse: 'Select Warehouse',
                confirm_select: 'Confirm Selection',
                skip_without_create_warehouse: 'Skip (Use default main warehouse)',

                inconfirm: {
                    confirm_in: 'Confirm Stock In',
                    error_popup: 'Error detected. Please verify and retry stock-in; the remaining core IDs were stocked in successfully',
                    error_popup_one: 'Error detected. Please verify and try inbound again',
                    error_popup_two: 'This product is not within the inbound scope. Please verify and try again',
                    error_popup_three: 'Some roll numbers are not within the inbound scope. Please verify and try again',
                    newscan: 'Rescan',
                    in_success: 'Stock-in completed successfully',
                    novalid_in: 'Invalid entry',

                },
                stock: {
                    count: 'Quantity:',
                    stock_all_count: 'Total inventory:',
                    stockin: 'Stocked in',
                    info: 'Transfer Information',
                    instock: 'In Stock',
                    instock_time: 'Stock-in Time',
                    warehouse_name: 'Warehouse Full Name',

                }
            },
            out: {
                title_unstockout: 'To Ship',
                title_stockrecord: 'Outbound Log',
                title_querystock: 'Inventory',
                search_placeholder: 'Please enter roll number to search',
                title: 'Time:',
                out_stock_time: 'Outbound Date',
                out_stock_time_two: 'Outbound Time',
                out_stock_record_count: 'Total Outbound Records',
                plan_purchase_count: 'Total Purchase Qty',
                real_out_count: 'Total Actual Outbound Qty',
                unout: {
                    select_purchase_distributor: 'Please select a purchasing distributor/retailer',
                    select_outbount_targetobject: 'Please select the outbound destination',
                    scan_out: 'Scan to stock out',
                    summary_kind_label: 'Product types',
                    summary_kind_unit: '',
                    summary_pending_label: 'Total to ship',
                    no_select_distributor: 'Please select a distributor first',
                    no_select_targetobject_desc: 'Please select an outbound destination first',
                    search_outbound_target_name: 'Search by name',
                    distributor_un_out_count: 'Distributor/Retailer To-Ship Qty',
                    targetobject_un_out_count: 'Target Pending Outbound Qty',
                    out_count: 'Outbound Qty',
                    plannedpurchase_count: 'Planned Purchase Qty',

                    out_count_new: 'Actual Outbound Qty',
                    plannedpurchase_count_new: 'Purchase Qty',

                },
                outconfirm: {
                    confirm_in: 'Confirm Outbound',
                    error_popup: 'Error detected. Please verify and retry outbound; the remaining core IDs were stocked out successfully',
                    error_popup_one: 'Error detected. Please verify and try outbound again',
                    error_popup_two: 'This product is not within the outbound scope. Please verify and try again',
                    error_popup_three: 'Some roll numbers are not within the outbound scope. Please verify and try again',
                    newscan: 'Rescan',
                    in_success: 'Stock-out completed successfully',
                    novalid_in: 'Invalid entry',
                },
                unoutdetail: {
                    tag_unout: 'Pending Outbound',
                    scan_out: 'Scan to Outbound',
                    confirm_out: 'Confirm Outbound',
                    serial: 'Roll Number',
                    check_product_error: 'This product does not match the roll core number. Please verify and try again',
                    stock_out_success: 'Stock-out completed successfully',
                    all: 'All',
                    all_new: 'All Merchants',

                }
            },


        },
        selectrolepopup: {
            changerole: 'Switch Role',
            createnewrole: 'Create New Role',
            searchplaceholder: 'Search role type or company name',
            clearsearch: 'Clear',
            totalroles: '{count} roles available',
            noresults: 'No matching roles found',
            noresultsdesc: 'Try another keyword, such as distributor name or role type',
        },

        qastepform: {
            multi_product_incomplete: 'Some required information is incomplete',
            steporigin: {
                stepone: '1. Scan Product Information -',
                steptwo: '2. Fill in Vehicle Information -',
                stepthree: '3. Upload Installation Photos -',
                stepfour: '4. Submit Completed'
            },

            stepone: {
                scantop: 'Step 1 Scan Product Information',
                productname: 'Product Name',
                serialnumber: 'Roll Number',
                expiredate: 'Warranty Period',
                qacontent: 'Warranty Content',
                retailer: 'Retailer',
                record_product: 'Recorded Product',
                delete: 'Delete',
                next: 'Continue Entry',
                submit: 'Finish Entry\nNext Step',
                // rollnumberplaceholder: 'If scanning fails, please enter the roll number manually',
                rollnumberplaceholder: 'Please enter the roll number',
                rollnumberverify: 'Verify',
                scanProductInfo: 'Scan to get product information',
                scanProductInfoError: '(If recognition fails, please enter the roll number manually to verify)',

                popup: {
                    tips_title: 'Notice',
                    role_not_match_create_qa: 'The current account role does not match and cannot create warranty.',
                    title: 'Are you sure you want to delete this roll number?',
                    confirm: 'Confirm',
                    cancel: 'Cancel',
                    retailer_confirm_title: 'Confirm Warranty Store',
                    retailer_confirm_lead: 'This product is stocked at ',
                    retailer_confirm_tail: '. Please confirm to create the warranty at this store.',
                    retailer_confirm_yes: 'Create here',
                    retailer_confirm_no: 'Wrong store',
                    retailer_not_match_title: 'Cannot Create Warranty',
                    retailer_not_match_lead: 'This product is stocked at ',
                    retailer_not_match_tail: ', which does not match the current store and cannot be warranted here. Please contact that store or customer support for help.',
                    retailer_not_match_confirm: 'Got it'
                },

                toast: {
                    select_component: 'Please select the installation part',
                    no_repeat_scan: 'Do not scan the same roll number repeatedly',
                    roll_number_noempty: 'Roll number cannot be empty',
                    rollnumberverify_success: 'Verification Successful',
                    distributor_channel_hint: 'This product belongs to the distribution channel. Warranty must be created by a retailer, or after stock-in.\nThank you for your understanding.',
                }
            },

            setptwo: {
                scantop: 'Step 2 Fill in Vehicle Information',
                carinfo: 'Vehicle Information',
                carownername: 'Owner Name',
                inputcarownername: 'Please enter the owner\'s name',
                next: 'Next Step',
                serialnumber: 'Roll Number',

                toast: {
                    answer_fill_all: 'Please check whether the questionnaire is complete',
                    carownername_fill_all: 'Please enter the owner\'s name',
                    phone_fill_all: 'Please enter the phone number',
                    code_fill_all: 'Please enter the verification code',
                    content_check_failed: 'Invalid data format',
                    singlechoice_check_failed: 'Please select data',
                    answer_fill_all_yes: 'Please check whether the questionnaire has been filled out correctly'
                }
            },

            stepthree: {
                scantop: 'Step 3 Upload Installation Photos',
                ztimg: 'Installation Photos',
                serialnumber: 'Roll Number',
                least: 'at least',
                most: 'at most',
                unit: '',
                show_below_info: 'Please add close-up photos of the installation on each part below',

                toast: {
                    success: 'Created Successfully',
                    img_upload_failed: 'The number of uploaded images does not match'
                }
            },

            redesign: {
                common: {
                    step_title: 'Step {step} · {title}',
                    product_progress: 'Product {current} / {total}',
                    product_tab: 'Product {index}',
                    prev_product: 'Previous',
                    next_product: 'Next',
                    need_help: 'Need help?',
                    input_mode_aria: 'Entry method',
                    list_separator: ', '
                },
                stepone: {
                    verify_success_label: 'Roll number verified:',
                    task_desc: 'Enter or scan the roll number, then verify to view product info and parts',
                    manual_input: 'Manual entry',
                    scan_input: 'Scan code',
                    select_warranty_parts: 'Select warranty parts',
                    parts_selected: 'Selected {selected}/{total}',
                    continue_entry_title: 'Continue adding products',
                    entry_title: 'Add product',
                    entry_status_current_total: 'Adding product {index} of {total}',
                    entry_status_current: 'Adding product {index}'
                },
                steptwo: {
                    task_desc_single: 'Complete the vehicle questionnaire and contact details',
                    task_desc_multi: 'Complete a questionnaire per product; mounting date and phone are shared',
                    switch_product_hint: 'Use the buttons below to switch products and complete all questionnaires',
                    mount_and_contact: 'Installation & contact',
                    multi_product_shared: 'Shared across products',
                    shared_hint_default: 'Mounting date and owner phone only need to be entered once for all products',
                    shared_hint_zhongsheng: 'Mounting date only needs to be entered once',
                    account_phone: 'Account phone',
                    change_phone: 'Change phone number',
                    fill_owner_phone: 'Please enter the owner phone number',
                    use_account_phone: 'Use my account info',
                    privacy_dialog_title: 'Privacy notice',
                    privacy_dialog_message: 'Per Zhongsheng Group channel privacy guidance, the owner\'s real name and mobile number should be kept confidential. Authorize filling in your account name [{name}] and mobile number [{phone}]?',
                    privacy_dialog_confirm: 'Authorize',
                    privacy_dialog_manual: 'Enter manually',
                    toast_creator_info_applied: 'Your account details have been applied',
                    toast_account_phone_applied: 'Account phone number applied',
                    toast_no_account_phone: 'No phone linked to account; please enter manually'
                },
                stepthree: {
                    task_desc_single: 'Upload installation photos and part close-ups as required',
                    task_desc_multi: 'Upload installation photos for each product; use the buttons below to switch',
                    switch_product_hint: 'Use the buttons below to switch products and complete all photo uploads',
                    warranty_files_title: 'Warranty files',
                    warranty_files_desc: 'Vehicle installation and roll number photos',
                    component_closeup_title: 'Part close-ups',
                    component_closeup_desc: 'Close-up photos of each installed part',
                    pending_upload_hint: 'Products {products} still have photos to upload'
                }
            }
        },


        qapublicquery: {
            hero_title: 'Auto Film Warranty',
            hero_desc: 'Enter your VIN to view official warranty details.',
            logo_alt: 'Castrol Auto Films',
            search_card_title: 'VIN lookup',
            search_card_hint: 'Enter the full vehicle identification number (VIN).',
            trust_no_login: 'No sign-in',
            trust_instant: 'Instant lookup',
            trust_official: 'Official warranty',
            guide_phone: 'Phone',
            guide_or: 'or',
            guide_vin: 'VIN',
            guide_result: 'View results',
            landing_title: 'Start your search',
            landing_desc: 'Enter a VIN and tap Search to view warranty details.',
            landing_caption: 'View full warranty details after searching',
            landing_tap_hint: 'Tap the card above to begin',
            landing_preview_code: 'Warranty No.',
            landing_preview_product: 'Product',
            landing_preview_period: 'Coverage period',
            landing_feature_status: 'Status',
            landing_feature_detail: 'Product info',
            landing_feature_verify: 'Verified',
            empty_title: 'No warranties found',
            loading: 'Searching…',
            result_count: '{count} warranty record(s) found',
            result_found: 'Warranty record found',
            vin_required: 'Please enter a VIN',
            mock_notice: 'Showing demo data until the public API is available.',
            search_failed: 'Search failed. Please try again later.',
            warranty_not_found: 'No matching warranty record found',
            login_guide_title: 'Need more features?',
            login_guide_desc: 'Sign in to create warranties, manage orders, and access full services.',
            login_guide_action: 'Search by phone',
            create_qa_action: 'Create warranty',
            float_actions_expand: 'Show quick actions',
            float_actions_collapse: 'Hide quick actions',
        },

        qasteplist: {
            topphonesearch: 'Please enter phone number to search',
            search: {
                hint: 'Search by phone number or VIN',
                vin_hint: 'Search by VIN',
                phone_label: 'Phone',
                phone_placeholder: 'Enter phone number',
                vin_label: 'VIN',
                vin_placeholder: 'Enter VIN',
                submit: 'Search',
                reset: 'Clear',
                require_one: 'Enter a phone number or VIN to search',
                require_vin: 'Enter a VIN to search',
                empty_desc: 'No matching warranties\nTry adjusting your search.',
                edit: 'Edit'
            },
            list_meta: '{count} records',
            list_lead: 'Matching warranty records',
            list_empty_lead: 'No warranty records yet',
            tab: {
                all: 'All',
                unapprove: 'Pending',
                approved: 'Activated',
                rejected: 'Rejected'
            },
            item: {
                product: 'Product',
                phone: 'Phone Number',
                vin: 'VIN',

                unapprove: 'Pending',
                approved: 'Activated',
                rejected: 'Rejected'
            }
        },

        qastepreview: {
            search: 'Filter',
            tab: {
                all: 'All',
                unapprove: 'Pending',
                approved: 'Approved',
                rejected: 'Rejected'
            },
            item: {
                product: 'Product',
                phone: 'Phone Number',

                unapprove: 'Pending',
                approved: 'Approved',
                rejected: 'Rejected'
            },
            review_success: 'Review Successful',

        },
        qastepdetail: {
            qastatus: 'Warranty Status',
            carinfo: 'Vehicle Information',
            productname: 'Product Name',
            serialnumber: 'Roll No',
            expireddate: 'Warranty Period',
            qacontent: 'Warranty Content',
            mountparts: 'Installed Parts',
            qastarttime: 'Warranty Start Date',
            mountinfo:'Mounting Information',
            mounttime: 'Mounting Date',
            retailer: 'Retailer',
            zt_img: 'Warranty Images',
            review: 'Review',

            carownername: 'Owner Name',
            carownerphone: 'Owner Phone',

            unapprove: 'Pending',
            approved: 'Activated',
            rejected: 'Rejected',

            screenshot: {
                save: 'Save long screenshot',
                capturing: 'Generating long screenshot',
                capturing_hint: 'Preparing page content, please wait',
                capturing_slice: 'Stitching segment {current}/{total}',
                capturing_saving: 'Saving image',
                saved: 'Long screenshot saved',
                segmented: 'Long content saved as {count} segmented screenshots',
                preview_title: 'Long screenshot preview',
                preview_hint: 'Long-press the image to save to album',
                preview_close: 'Close preview',
                preview_prev: 'Previous',
                preview_next: 'Next'
            },

            qrcode: {
                open: 'Share',
                hint: 'Scan to view this warranty',
                missing_vin: 'VIN is missing; cannot generate QR code',
                save: 'Save to album',
                save_hint: 'Long-press the image to save to album',
                saved: 'QR code saved',
                save_fail: 'Save failed. Please try again',
                copy_link: 'Copy Link',
                copy_success: 'Link copied',
                copy_fail: 'Copy failed. Please try again',
                close: 'Close'
            },

            ppf_warranty: {
                detail_title: 'Warranty Coverage Details',
                detail_link: 'Details',
                detail_html: '<h5>Staining, cracking, delamination, rain spots, obvious surface defects present before installation, yellowing, and hydrolysis caused by non-human factors are covered under warranty.</h5><h5>Warranty Coverage Details:</h5><ol class="ppf-list ppf-list--en"><li>Staining refers to loss of gloss on the film surface, resulting in a dull or patchy appearance;</li><li>Cracking refers to embrittlement of the film surface with cracking occurring;</li><li>Delamination refers to automatic separation between the adhesive layer and the film layer under normal use after installation;</li><li>Rain spots refer to very obvious and irremovable marks left by rainwater on the film surface;</li><li>Obvious surface defects before installation means that before installation, only the following conditions were found: white spots, obvious foreign matter, gel, obvious diagonal lines, etc.;</li><li>Yellowing refers to obvious yellowing of the film surface; slight yellowing is normal and not covered by warranty, i.e. ΔE &lt; 2, with no after-sales liability;</li><li>Hydrolysis refers to the film having melted onto the paint surface and being unable to be removed;</li><li>Edge lifting (edge lifting more than one month after handover upon completion of installation is covered; within one month is considered an installation technique issue—return to the store for re-edging).</li></ol><h5>Note:</h5><p>Paint protection film contaminated by car wash fluid, tar remover, tar, or other chemical agents is not covered under warranty.</p>',
                detail_aria: 'View warranty coverage details'
            }
        },


        distributorcoupon: {
            topsearch: {
                content: 'Please enter phone number to search',
                search: 'Search'
            },
            tabs: {
                all: 'All',
                undo: 'Unredeemed',
                done: 'Redeemed'
            },
            phone: 'Phone Number',

            scan: {
                submit: 'Confirm Redemption',
                scan_success: 'Redemption Successful'
            }
        },


        newdealershop: {
            fullname: 'Business/Company Full Name',
            area: 'Region',
            address: 'Address',
            level: 'Level',
            createtime: 'Created At',
            cartype: 'Document Type',   // 若特指身份证件，可用 'ID Type'
            carimg: 'Document Photo',   // 若特指身份证件照片，可用 'ID Photo'
        },

        logout: {
            title: 'Are you sure you want to log out?',
            confirm: 'Confirm',
            cancel: 'Cancel'
        },

        newpurchasedetail: {
            product_info: 'Product Information',
            purchase_id: 'Purchase Order ID',
            purchase_date: 'Purchase Date',
            purchase_people: 'Purchaser',
            purchase_people_phone: 'Purchaser Phone Number',

            distributor_info: 'Distributor Information',

            company_name: 'Company Name',
            people_number: 'Taxpayer Identification Number',
            address: 'Address',
            phone: 'Phone'
        },


        newpurchasemanagerdetail: {
            product_info: 'Product Information',
            purchase_id: 'Purchase Order ID',
            purchase_date: 'Purchase Date',
            purchase_company: 'Purchasing Company',
            purchase_people: 'Purchaser',
            purchase_people_phone: 'Purchaser Phone Number',
        },


        shoporder: {
            orderlist: 'Transaction List',

            goorder: 'Purchase',

            style: 'Model',

            no_sku_price_tips: 'Price unavailable',

            current_sku_no_price_tips: 'Ordering unavailable for this SKU',

            first_select_address: 'Please select an address first',

            create_payment_success: 'Created successfully',

            please_retry_select_goods: 'The currently selected item has no price available, please choose another one.',

            go_to_payment: 'Proceed to create payment order?',
            payment_create_confirm: "Create",
            payment_create_back: "Back",

            all_price: 'Total',
            search: {
                search_input_order_placeholder: 'Please enter the transaction ID to search',
                search_input_payment_placeholder: 'Please enter the payment ID',

            },

            orderitem: {
                orderid: 'Order ID',
                channelinfo: 'Channel',
                orderdate: 'Order Date',
                orderperson: 'Ordered By',
                orderphone: 'Buyer Phone',
                buyerpartytype: 'Buyer Party Type',
                buyerpartyname: 'Buyer Party',
                buy_from: 'Vendor',

                paymentorderid: 'Payment ID',
                paymentorderbuyertype: 'Payer Type',
                paymentorderbuyername: 'Payer Name',
                createorderdate: 'Created Date',
                paymentorderdate: 'Payment Date',
                confirmorderdate: 'Confirmed Date',
                paymentorderinfo: 'Payment Info',

                orderamount: 'Amount',
                orderaddress: 'Address',

                changestatus: 'Change Status',

                statusscuess: 'Status Updated',

                change_status_confirming: 'Pending',
                change_status_confirmed: 'Confirmed',
                change_status_closed: 'Closed',

                payment_method: 'Payment Method',

                payment_time: 'Payment Time',
                payment_time_now: 'Current Time',
                payment_time_manual: 'Adjust Manually',
                id: 'ID',

            },

            orderdetail: {
                gobuy: 'Create Payment Order',
                viewgodetail: 'View delivery details',
                gosend: 'Ship Now',
                sku_amount: 'SKU Amount',
                distribution_costs: 'Delivery Fee',
                sku_reduce: 'SKU Discount',
                discount_amount: 'Discount Amount',
                really_pay: 'Actual Payment',

                channel_title: 'Channel Information',
                channel_id: 'Channel ID',
                channel_name: 'Channel Name',
                channel_type: 'Channel Type',
                buyer_title: 'Buyer Information',
                store_title: 'Store Information',
                order_info: 'Order Information',
                store_id: 'Store ID',
                store_name: 'Store Name',

                pricedetail: 'Price Details',
                paymentmethod: 'Payment Method',
                orderpayment: 'Payment Order Details',
                watch_bank_info: 'View Bank Information',
                up_bank_info: 'Collapse',

                createorder: 'Create Order',

                padding_pay_amount: 'Amount Pending Payment',
                padding_confirming_amount: 'Amount Pending Confirmation',
                confirmed_amount: 'Confirmed Amount',

                paymentamount: 'Payment Required',
                createpaytime: 'Creation Time',

                buyerpartid: 'Buyer ID',
                buyertype: 'Buyer Type',
                buyerstyle: 'Buyer Type',
                buyerpartname: 'Buyer Name',
                buyerpeople: 'Order Placer',
                buyerphonenumber: 'Placer Phone Number',

                buyerpeople_new: 'Payer',
                buyerphonenumber_new: 'Payer Phone',


                order_id: 'Order ID',
                order_time: "Order Time",
                order_status: 'Order Status',

                formatted: 'Formatted',
                added: 'Added',
                select_full_date: 'Select Full Date',

                full_date_year: 'Year',
                full_date_month: 'Month',
                full_date_day: 'Day',
                full_date_hour: 'Hour',
                full_date_minute: 'Minute',
                full_date_second: 'Second',

                confirm: 'Confirm',
                cancel: 'Cancel',

                alipay_redirecting: 'Launching Alipay payment, please wait…',
                alipay_querying: 'Checking payment status, please wait…',
                alipay_success: 'Payment successful',
                alipay_back: 'Back',
                alipay_scan_tip: 'Scan with Alipay to pay',
                alipay_scan_sub: 'Payment will be detected automatically',

                buyer_title_order_new: 'Payer Info',

                order_info_new: 'Order Information',

                buyer_title_new_title: 'Payer Information',

                buyerpartid_new: 'Payer ID',
                buyerstyle_new: 'Payer Type',
                buyerpartname_new: 'Payer Name',
                buyerpeople_new: 'Payer',
                buyerphonenumber_new: 'Payer Phone Number',

                transactionNo_detail: 'Transaction Number',
                enter_transactionNo: 'Please enter',
                confirm_date: 'Confirmation Time',


                payment_date: 'Payment Date',




            },

            // ordermanager: {
            //     tab: {
            //         all: 'All',
            //         unpay: 'Pending Payment',
            //         unconfirmed: 'Pending Confirmation',
            //         partpay: 'Partially Confirmed',
            //         payed: 'Confirmed',
            //         closed: 'Closed',
            //     }
            // },
            // ordermanager: {
            //     tab: {
            //         all: 'All',
            //         unpay: 'Unpaid',
            //         unconfirmed: 'To Confirm',
            //         partpay: 'Partial',
            //         payed: 'Confirmed',
            //         closed: 'Closed',
            //     }
            // },
            ordermanager: {
                tab: {
                    all: 'All',
                    unpay: 'Unpaid',
                    unconfirmed: 'Check',
                    partpay: 'Partial',
                    payed: 'Paid',
                    closed: 'Closed',
                }
            },

            stockout: {
                //出库的一些提示
                totalQty: 'Total Quantity',
                pendingOutboundQty: 'Pending Outbound Quantity',
                pendingInboundQty: 'Pending Inbound Quantity',
                inboundQty: 'Inbound Quantity',

                outboundtime: 'Outbound Time',
                outboundoperation: 'Outbound Instructions',
                outboundoperation_placeholder: 'Enter outbound instructions'
            },


            store: {
                storeid: 'ID',
                storename: 'Name'
            },


        },

        service: {
            servicecenter: {
                search_input_servicecenter_placeholder: 'Please enter the service center name to search',
                create: 'Create Service Center',

                creation: {
                    name: 'Service Center Name',
                    workcount: 'Number of Workstations',
                    confirm: 'Confirm',
                    confirmcreate: 'Confirm Creation',
                    create_success_tips: 'Service Center Created Successfully'
                },

                detail: {
                    name: 'Service Center Name',
                    address: 'Region',
                    fulladdress: 'Full Address',
                    contractphone: 'Contact Phone',
                    workcount: 'Number of Workstations'
                }
            },
            manager: {
                search: {
                    content: 'Please enter service name'
                },
                tab: {
                    all: 'All',
                    not_scheduled: 'Unscheduled', // 或 Pending Appointment
                    scheduled: 'Scheduled',       // 或 Appointed
                    served: 'Served',             // 或 Completed / Processed
                    not_required: 'No Service Required',
                },
                detail: {
                    amount_all: 'Total'           // 或 Total Amount
                }
            }
        },

        address: {
            list: {
                search_input_address_placeholder: 'Please enter address to search',
                create: 'Add New Address'
            },

            create: {
                owneraddress: 'Region',
                fulladdress: 'Detailed Address & Door Number',
                name: 'Recipient Name',
                saveaddress: 'Save Address',
                successtips: 'Address created successfully',

            },
            detail: {
                country: 'Country/Region',
                fulladdress: 'Detailed Address',
                recipientName: 'Recipient Name',
                phone: 'Phone Number'
            }
        },

        warehouse: {
            list: {
                search_input_address_placeholder: 'Enter warehouse name to search',
                create: 'Add Warehouse'
            },
            create: {
                owneraddress: 'Region',
                fulladdress: 'Detailed address and door number',
                name: 'Full Warehouse Name',
                savewarehouse: 'Save warehouse',
                successtips: 'Warehouse created successfully'
            },
            detail: {
                first_select_warehouse: 'Select warehouse first',
                verify: 'Verify',
                confirm: 'Confirm'
            }
        },


        storemanager: {
            detail: {
                fullname: 'Store Name',
                salesStatus: 'Sales Status',
                shoplogo: 'Store Logo'
            }
        },


        charts: {
            qachart: {
                name: 'Quality Assurance Report'
            },
            purchasechart: {
                name: 'Procurement Report'
            },
            inoutstockchart: {
                name: 'Inventory Inbound Outbound Report'
            }
        },

        apptheme: {
            themesystem: 'THEME SYSTEM',

        },



        errorinfopopup: {
            title: 'Error Information',
            detail: 'Details',
            close: 'Close'
        },


        docker: {
            website: 'Home',
            main: 'Map',
            scheme: 'Style',
            mine: 'Mine'
        }
    }
};